import { BO, BusinessObjectBase, NonUniqueModelDataError, RepositoryResponseConflictCodes, ResponseConflictObject, Weaver } from '@skylab-shared/core';
import { MailTemplateModel } from '@skylab-shared/dataModel';
import { sameValues } from '@skylab-shared/utils';

@BO({ modelType: MailTemplateModel })
export class MailTemplateBO extends BusinessObjectBase<MailTemplateModel> {
    public constructor(
        weaver: Weaver,
    ) {
        super(weaver);
    }

    protected override async initializeAsync(): Promise<void> {
        await super.initializeAsync();

        this.readonly.addRule(
            [[MailTemplateModel, 'kind']],
            ctx => ctx.source.isPersistent
        );
    }

    protected override handleConflictSaveResponse(conflict: ResponseConflictObject<RepositoryResponseConflictCodes>) {
        if ((conflict.code === RepositoryResponseConflictCodes.UniqueConstraintViolation) && sameValues(conflict.objectProperties!, ['name'])) {
            this.addExternalRuleViolations({
                [this.model.sun]: [{
                    property: 'name',
                    violation: new NonUniqueModelDataError('business.mail-template.validation.name.server-rule-violations.non-unique-model-data-error')
                }]
            });
        }
    }
}
